import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import LOGOTRANSPARENT from "../assets/logo_2-removebg-preview.png";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-[#C7B9A5] shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="text-2xl font-light text-white">
          <img src={LOGOTRANSPARENT} alt="Beautique Mariam Logo" className="h-10 w-auto" />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-8 text-[#7A6E62] font-light">
          <Link to="/" className="hover:text-[#C7B9A5] transition">
            Startseite
          </Link>
          <Link to="/ueber-uns" className="hover:text-[#C7B9A5] transition">
            Über uns
          </Link>
          <Link to="/leistungen" className="hover:text-[#C7B9A5] transition">
            Leistungen
          </Link>
          <Link to="/kontakt" className="hover:text-[#C7B9A5] transition">
            Kontakt
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-[#7A6E62] focus:outline-none"
          >
            {isOpen ? (
              <XIcon className="w-6 h-6" />
            ) : (
              <MenuIcon className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <nav className="md:hidden bg-white shadow-md px-6 py-4 space-y-4 text-center text-[#7A6E62] font-light">
          <Link
            to="/"
            className="block hover:text-[#C7B9A5] transition"
            onClick={() => setIsOpen(false)}
          >
            Startseite
          </Link>
          <Link
            to="/ueber-uns"
            className="block hover:text-[#C7B9A5] transition"
            onClick={() => setIsOpen(false)}
          >
            Über uns
          </Link>
          <Link
            to="/leistungen"
            className="block hover:text-[#C7B9A5] transition"
            onClick={() => setIsOpen(false)}
          >
            Leistungen
          </Link>
          <Link
            to="/kontakt"
            className="block hover:text-[#C7B9A5] transition"
            onClick={() => setIsOpen(false)}
          >
            Kontakt
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
